import angular from 'angular';
import searchBoxTitleTpl from './search-box-title.tpl.html!text';

class SearchBoxTitleCtrl {

    constructor($element, helperServ) {
        this.$element = $element;
        this.helperServ = helperServ;

        this.$element.ready(this.onElementReady.bind(this));
    }

    onElementReady() {
        this.geolocationSupport = this.helperServ.checkForGeolocationSupport();
        
        if (this.geolocationSupport) {
            this.$element.find('.search-box-title-with-geolocation').removeClass('search-box-title-hidden');
        } else {
            this.$element.find('.search-box-title-without-geolocation').removeClass('search-box-title-hidden');
        }
    }
}

SearchBoxTitleCtrl.$inject = ['$element', 'helperServ'];

var searchBoxTitleComponent = function() {
    return {
        restrict: 'E',
        scope: {},
        template: searchBoxTitleTpl,
        controllerAs: 'searchBoxTitleCtrl',
        controller: SearchBoxTitleCtrl
    };
};

export default angular.module('search-box-title', [])
    .directive('searchBoxTitle', searchBoxTitleComponent)
    .name;